import React from 'react';
import { Users, ClipboardList, Truck, Receipt, IndianRupee, Bell, BarChart3, UsersRound, Sparkles, Check, X } from 'lucide-react';
import Navbar from '../../components/website/Navbar';
import Footer from '../../components/website/Footer';

const groups = [
  { icon: Users, title: 'Customer Management', items: ['Unlimited customers with address, area, notes', 'Search, filter, import via CSV', 'Customer ledger, dues, subscriptions in one view'] },
  { icon: ClipboardList, title: 'Subscription Management', items: ['Daily / weekday / custom schedules', 'Pause / resume in one tap', 'Customer-specific pricing'] },
  { icon: Truck, title: 'Delivery Operations', items: ['Auto-generated daily delivery list', 'Bulk mark whole route delivered', 'Route sheets to print or export'] },
  { icon: Receipt, title: 'Billing & Invoices', items: ['Monthly invoices from actual deliveries', 'Adjustments, previous balance', 'Share on WhatsApp, download PDF'] },
  { icon: IndianRupee, title: 'Payments', items: ['Cash / UPI / Bank / Card', 'Partial and advance payments', 'Reminder scheduling'] },
  { icon: Bell, title: 'Notifications', items: ['New vacation, quantity change', 'Payment received, invoice overdue', 'In-app + email'] },
  { icon: BarChart3, title: 'Reports', items: ['Daily delivery, monthly revenue', 'Product sales, wastage', 'Outstanding & customer ledger'] },
  { icon: UsersRound, title: 'Staff & Routes', items: ['Assign staff to routes', 'Track delivery performance', 'Custom permissions'] },
  { icon: Sparkles, title: 'AI Business Assistant', items: ['Understand plain-language commands', '"What should I prepare tomorrow?"', 'Confirmation before critical changes'] },
];

export default function Features() {
  return (
    <div className="bg-rozops-bg min-h-screen">
      <Navbar />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-1.5 rounded-full bg-rozops-blue-light text-rozops-blue text-xs font-semibold px-3 py-1">Features</div>
          <h1 className="mt-4 font-heading font-extrabold text-4xl sm:text-5xl text-rozops-navy tracking-tight">Everything you need to manage daily business operations</h1>
          <p className="mt-4 text-lg text-rozops-text-muted">Purpose-built for merchants who sell recurring, low-margin products to hundreds of neighbourhood customers.</p>
        </div>
        <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {groups.map(({ icon: Icon, title, items }) => (
            <div key={title} className="bg-white rounded-2xl border border-gray-100 shadow-soft p-6">
              <div className="w-11 h-11 rounded-xl bg-rozops-blue-light text-rozops-blue grid place-items-center mb-4">
                <Icon className="w-5 h-5" strokeWidth={2.2} />
              </div>
              <div className="font-heading font-bold text-lg text-rozops-navy mb-3">{title}</div>
              <ul className="space-y-2">
                {items.map(it => (
                  <li key={it} className="flex items-start gap-2 text-sm text-rozops-text-muted"><Check className="w-4 h-4 text-rozops-green flex-shrink-0 mt-0.5" /> {it}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Comparison */}
        <div className="mt-16 bg-white rounded-3xl border border-gray-100 shadow-soft overflow-hidden">
          <div className="grid md:grid-cols-2">
            <div className="p-8 bg-red-50/60">
              <div className="font-heading font-bold text-xl text-rozops-navy mb-4 flex items-center gap-2"><X className="w-5 h-5 text-red-500" /> Without RozOps</div>
              {['Notebook + WhatsApp chaos', '3-4 hrs to make monthly bills', 'Frequent quantity mistakes', 'Payment tracking on paper'].map(t => (
                <div key={t} className="flex items-start gap-2 text-sm text-rozops-text-muted py-1.5">• {t}</div>
              ))}
            </div>
            <div className="p-8 bg-rozops-green-light">
              <div className="font-heading font-bold text-xl text-rozops-navy mb-4 flex items-center gap-2"><Check className="w-5 h-5 text-rozops-green" /> With RozOps</div>
              {['Everything digital, searchable', 'Invoices in 5 minutes', 'Zero missed changes', 'Live payment status'].map(t => (
                <div key={t} className="flex items-start gap-2 text-sm text-rozops-text py-1.5"><Check className="w-4 h-4 text-rozops-green flex-shrink-0 mt-0.5" /> {t}</div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
